import { Injectable } from '@angular/core';
import { DataService } from '../data.service';
import { CashDeskCloseControlSearchItem } from '../../model/cash-desk-close-control/cash-desk-close-control-search-item';
import { ReportViewer } from 'src/app/model/report-viewer';
import { CashDeskCloseControlPayment } from '../../model/cash-desk-close-control/cash-desk-close-control-payment';

@Injectable({
  providedIn: 'root'
})
export class CashDeskCloseControlService {

  constructor( private dataService: DataService ) { }

  private readonly getCashDeskCloseControlSearchItemEndPoint: string = '/cashDeskCloseControl/getCashDeskCloseControlSearchItem/';
  private readonly cashDeskCloseControlStateChangeEndPoint: string = '/cashDeskCloseControl/cashDeskCloseControlStateChange/';
  private readonly cashDeskCloseControlStateRollBackEndPoint: string = '/cashDeskCloseControl/cashDeskCloseControlStateRollBack/';
  private readonly cashDeskCloseControlReportEndPoint: string = '/cashDeskCloseControl/cashDeskCloseControlReport/';

  private readonly exportEndPoint: string = '/cashDeskCloseControl/export/';
  private readonly getFromExportEndPoint: string = '/cashDeskCloseControl/getFromExport/';

  async export(from: Date, to: Date): Promise<number> {

   const params = {
     From: new Date(from.getFullYear(), from.getMonth(), from.getDate()).toDateString(),
     To: new Date(to.getFullYear(), to.getMonth(), to.getDate()).toDateString()
   };

   return await this.dataService.post<number>
         (this.exportEndPoint, params).toPromise();
 }

 async getFromExport(): Promise<Date | null> {
  const params = { };
  return await this.dataService.get<Date | null>
        (this.getFromExportEndPoint, params).toPromise();
}

  async cashDeskCloseControlReport(from: Date, to: Date,
     cashDeskCloseControlPayments: CashDeskCloseControlPayment[]): Promise<ReportViewer> {

    const params = {
      From: new Date(from.getFullYear(), from.getMonth(), from.getDate()).toDateString(),
      To: new Date(to.getFullYear(), to.getMonth(), to.getDate()).toDateString(),
      CashDeskCloseControlPayments: cashDeskCloseControlPayments
    };

    return await this.dataService.post<ReportViewer>
          (this.cashDeskCloseControlReportEndPoint, params).toPromise();
  }

  async getCashDeskCloseControlSearchItem( protocol: string, from: Date,  to: Date,
      noControled: boolean, controled: boolean, observated: boolean, serviceId?: number, closeNumber?: number,
      paymentId?: number, invoicePointId?: number ): Promise<CashDeskCloseControlSearchItem[]> {
        const params = {
          protocol: protocol,
          from: new Date(from.getFullYear(), from.getMonth(), from.getDate()).toDateString(),
          to: new Date(to.getFullYear(), to.getMonth(), to.getDate()).toDateString(),
          noControled: noControled,
          controled: controled,
          observated: observated,
          serviceId: serviceId,
          closeNumber: closeNumber,
          paymentId: paymentId,
          invoicePointId: invoicePointId };
        return await this.dataService.get<CashDeskCloseControlSearchItem[]>
              (this.getCashDeskCloseControlSearchItemEndPoint, params).toPromise();
  }

  async cashDeskCloseControlStateChange( invoiceCashDeskIds: number[], invoiceCashDeskManualIds: number[],
    cashDeskCloseStateId: number, observation: string): Promise<boolean> {
    const params = {
      InvoiceCashDeskIds: invoiceCashDeskIds,
      InvoiceCashDeskManualIds: invoiceCashDeskManualIds,
      CashDeskCloseStateId: cashDeskCloseStateId,
      Observation: observation };
    return await this.dataService.post<boolean>
          (this.cashDeskCloseControlStateChangeEndPoint, params).toPromise();
  }

  async cashDeskCloseControlStateRollBack( invoiceCashDeskIds: number[], invoiceCashDeskManualIds: number[]): Promise<boolean> {
    const params = {
      InvoiceCashDeskIds: invoiceCashDeskIds,
      InvoiceCashDeskManualIds: invoiceCashDeskManualIds
    };
    return await this.dataService.post<boolean>
          (this.cashDeskCloseControlStateRollBackEndPoint, params).toPromise();
  }
}
